const chatAccountTabNames = {
  General: 'General',
  'Channel switching': 'Channel switching',
  'Context data': 'Context data',
  Security: 'Security',
  Installation: 'Installation',
  'Proactive Messaging': 'Proactive Messaging',
  Languages: 'Languages',
  'Push notifications': 'Push notifications',
  'Proactive chat': 'Proactive chat',
  Styling: 'Styling',
  Language: 'Language',
};

const chatBannerMessages = {
  channel_added: 'channel successfully added to conversation transfer',
  channel_add_failed: 'Failed to add channel to conversation transfer',
  channel_transfer_delete_failed: `Failed to delete channel conversation transfer`,
  channel_transfer_deleted: 'conversation transfer successfully deleted',
  channel_switching_placement_updated: 'Successfully updated channel switching control placement info',
  channel_switching_placement_update_failed: 'Failed to update channel switching control placement info',
  logo_upload_failed: 'Failed to upload logo',
  logo_upload_success: 'Successfully uploaded company logo',
  logo_update_success: 'Successfully updated display company logo information',
  logo_update_failed: 'Failed to update display company logo information',
  emoji_icon_update_success: 'Successfully updated emoji picker information',
  emoji_icon_update_failed: 'Failed to update emoji picker information',
  attachment_icon_update_success: 'Successfully updated attachments information',
  toggle_without_iframe_update_success: 'Successfully updated load widget without iframe',
  toggle_without_iframe_update_failed: 'Failed to update load widget without iframe',
  attachment_icon_update_failed: 'Failed to update attachments information',
  footer_text_update_success: 'Successfully updated Powered by Pega',
  footer_text_update_failed: 'Failed to update Powered by Pega',
  typing_indicator_update_success: 'Successfully updated typing indicator information',
  typing_indicator_update_failed: 'Failed to update typing indicator information',
  hide_chat_launcher_update_success: 'Successfully updated chat launcher information',
  hide_chat_launcher_update_failed: 'Failed to update chat launcher information',
  requires_authentication_update_success: 'Successfully updated chat session control',
  requires_authentication_update_failed: 'Failed to update chat session control',
  previous_interactions_update_success: 'Successfully updated previous interactions configuration',
  previous_interactions_update_failed: 'Failed to update previous interactions configuration',
  general_information_updated: 'General Information successfully updated',
  general_information_update_failed: 'Failed to update General Information',
  widget_position_update_success: 'Successfully updated widget position',
  widget_position_update_failed: 'Failed to update widget position',
  widget_button_type_update_success: 'Successfully updated widget button type',
  widget_button_type_update_failed: 'Failed to update widget button type',
  tag_added: 'tag successfully added',
  tag_addition_failed: 'Failed to add tag',
  tag_deleted: 'tag successfully deleted',
  tag_delete_failed: 'Failed to delete tag',
  domain_deleted: 'domain successfully deleted',
  domain_delete_failed: 'Failed to delete domain',
  added_to_domains: 'successfully added to allowed domains',
  add_to_domains_failed: 'Failed to add to allowed domains',
  added_to_cookies: 'successfully added to allowed cookies',
  add_to_cookies_failed: 'Failed to add to allowed cookies',
  cookie_deleted: 'cookie successfully deleted',
  cookie_delete_failed: 'Failed to delete cookie',
  copy_snippet_success: 'Successfully copied snippet',
  notification_webhook_updated: 'URL successfully updated',
  notification_webhook_update_failed: 'Failed to update URL',
  header_added: 'Header successfully added',
  header_addition_failed: 'Failed to add header',
  header_deleted: 'Header successfully deleted',
  header_delete_failed: 'Failed to delete header',
  language_selection_update_success: 'Successfully updated select language from menu option',
  language_selection_update_failed: 'Failed to update select language from menu option',
  file_upload_failed: 'Failed to upload font file',
  file_upload_success: 'Successfully uploaded font file',
  language_template_upload_success: 'Successfully uploaded language template',
  language_template_upload_failed: 'Failed to upload language template',
  must_have_csv_extension: 'Uploaded file must have be in .csv format',
  language_code_removal_succeeded: 'Successfully removed the language code',
  language_code_removal_failed: 'Failed to remove language code from list',
  font_deleted: 'Font file successfully deleted',
  font_delete_failed: 'Failed to delete font file',
  display_avatars_update_success: 'Successfully updated display avatar option',
  display_avatars_update_failed: 'Failed to update display avatar option',
  avatar_upload_failed: 'Failed to upload avatar image',
  avatar_upload_success: 'Successfully uploaded avatar image',
  display_download_transcript_update_success: 'Successfully updated download transcript information',
  display_download_transcript_update_failed: 'Failed to update download transcript information',
  text_input_area_update_success: 'Successfully updated text input area option for quick reply',
  text_input_area_update_failed: 'Failed to update text input area option for quick reply',
  virus_scan_update_success: 'Successfully updated virus scan option',
  virus_scanupdate_failed: 'Failed to update virus scan option',
  font_update_success: 'Successfully selected font file',
  font_update_failed: 'Failed to select font file ',
  genai_watermark_update_success: 'Successfully updated GenAI watermark information for KMBuddy messages',
  genai_watermark_update_failed: 'Failed to update GenAI watermark information for KMBuddy messages',
  encrypt_attachment_update_success: 'Successfully updated encryption for attachments',
  encrypt_attachment_update_failed: 'Failed to update encryption for attachments',
};

const chatFormErrorMessages = {
  select_channel_error: 'Please select channel',
  select_connection_error: 'Please select connection',
  chat_heading_empty: 'Heading cannot be empty',
  color_empty: 'Color cannot be empty',
  display_message_empty: 'Display message cannot be empty',
  company_logo_criteria: 'Image must be square, .png, .jpg or .gif format and less than 500KB',
  valid_tag_error: 'Please enter valid tag',
  non_reserved_tag_error: 'Please enter non reserved tag',
  tag_empty_error: 'Tag cannot be empty',
  validate_cookie_error: 'Please enter valid cookie',
  font_file_criteria: 'Font file must be .ttf, .otf, .woff or .woff2 format',
  font_file_limit: 'Cannot upload more than 5 custom font files, please delete existing to add more',
};

const chatFormLabels = {
  chat: 'Chat',
  appearance: 'Appearance',
  widget: 'Widget',
  chat_heading: 'Chat heading',
  chat_headings: 'Chat headings',
  primary_color: 'Primary color',
  choose_an_option: 'Choose an option...',
  display_message: 'Display message',
  company_logo: 'Company logo',
  display_company_logo: 'Display company logo',
  upload_image: 'Upload Image',
  widget_config: 'Widget configuration',
  widget_style_config: 'Widget styling configuration',
  sdk_config: 'Mobile SDK configurations',
  display_emoji_icon: 'Enable emoji picker',
  display_download_transcript: 'Display download transcript option',
  display_attachment_icon: 'Allow customer to upload and send attachments',
  toggle_without_iframe: 'Load widget without using iframe',
  byok_attachment: 'Encrypt attachments with BYOK enabled',
  display_footer_text: 'Display Powered by Pega',
  display_typing_indicator: 'Display typing indicator',
  hide_chat_launcher: 'Remove default Widget Launcher',
  widget_position: 'Widget position',
  bottom_right: 'Bottom-right',
  bottom_left: 'Bottom-left',
  top_left: 'Top-left',
  top_right: 'Top-right',
  center_right: 'Center-right',
  center_left: 'Center-left',
  text: 'Text',
  icon: 'Icon',
  widget_button_type: 'Widget button type',
  text_orientation: 'Text orientation',
  button_text: 'Button text',
  horizontal: 'Horizontal',
  vertical: 'Vertical',
  language_option: 'Allow customers to change language from widget header drop-down',
  upload_font: 'Upload font file',
  widget_font: 'Custom fonts for widget',
  widget_font_note:
    'Please upload font file formats supported by most of the browsers. If not widget will render in default fonts.',
  avatar_option: 'Display avatars in chat widget',
  avatar_option_sdk: 'Display avatars in SDK',
  upload_image_bot: 'Upload bot avatar image',
  upload_image_user: 'Upload user avatar image',
  upload_image_csr: 'Upload CSR avatar image',
  widget_avatar_note:
    'To display custom avatars, upload image for the bot and/or CSR. Image must be round or square with empty corners, with aspect ratio of 1:1, .png, .jpg or .jpeg format and less than 500KB',
  twilio: 'Twilio',
  vonage: 'Vonage',
  create_whatsapp_type: 'Create WhatsApp via',
  create_sms_type: 'Create SMS via',
  input_textarea_config: 'State of text input area for quick reply type menu',
  enable_input: 'Keep text input area enabled',
  enable_input_conditional: 'Disable text input area with option to enable with a click',
  disable_input: 'Disable text input area until a quick reply item is selected',
  default_bot: 'Default bot avatar',
  default_user: 'Default customer avatar',
  default_csr: 'CSR name initials, sample name: John Doe',
  hidden: 'No avatar will be shown',
  virus_scan: 'Disable virus scanning for attachments',
  virus_scan_note: 'Adding virus scanning may increase latency for customers uploading attachments',
  header_text_color: 'Header text color',
  update_message_font_color: 'Update message and font color',
  color_theme_update_success: 'Successfully updated Primary color',
  head_text_color_update_success: 'Successfully updated Header text color',
  color_theme_update_failed: 'Failed to update Primary color',
  head_text_color_update_failed: 'Failed to update Header text color',
  read_only_download_transcript: 'Download transcript cannot be enabled while real-time translations is on',
  allow_typing_before_welcome_message: 'Allow customer to send message before first response is sent',
  allow_typing_before_welcome_message_update_success:
    'Successfully updated Allow customer to send message before first response is sent',
  allow_typing_before_welcome_message_update_failed:
    'Failed to update Allow customer to send message before first response is sent',
  disable_genAI_watermark: 'Hide Powered by Pega GenAI',
  disable_genAI_watermark_note:
    'When a message originates from KMBuddy, it will include a watermark informing the end user that it has been generated by Pega GenAI. Enabling this configuration will remove the watermark.',
  special_notes: 'Pinned messages',
  special_note: 'Pinned message',
  special_note_validation_error: 'Text input must be between 1 and 350 characters',
  special_note_option: 'Add Pinned message to the top of the chat conversation',
  enable_voice_to_text: 'Enable voice-to-text',
  enable_voice_to_text_update_success: 'Successfully updated voice-to-text',
  enable_voice_to_text_update_failed: 'Failed to update voice-to-text',
  enable_voice_notes: 'Enable voice notes',
  enable_voice_notes_update_success: 'Successfully updated voice notes',
  enable_voice_notes_update_failed: 'Failed to update voice notes',
  enable_heart_beat: 'Enable web socket health check',
  enable_heart_beat_update_success: 'Successfully updated web socket health check',
  enable_heart_beat_update_failed: 'Failed to update web socket health check',
  chat_heart_beat_confirm: 'Confirm web socket health check',
  chat_heart_beat_confirmation_intro:
    'By enabling this configuration, web socket health checks will be turned on for all new widget sessions in this deployment',
  chat_heart_beat_confirmation_point1: 'Existing active sessions will not be affected',
  chat_heart_beat_confirmation_point2:
    "If a customer's connection does not respond to web socket health checks, the connection will be closed and the customer will be reconnected to the existing session",
};

const channelHopperLabels = {
  add_channel: 'Add channel',
  channel: 'Channel',
  conversation_transfer: 'Conversation transfer',
  channels_transferred_to_title_text: 'Select which channels a conversation can be transferred to',
  channel_switching_control_placement: 'Channel switching control placement',
  top_right_menu: 'Top right menu',
  visible_in_header: 'Visible in header',
  simultaneous_conversation: 'Simultaneous conversations with a Mobile Messaging connection',
  share_interaction: 'Share interaction with a Mobile Messaging connection',
  connection_to_share_with: 'Choose the connection to share with',
  sync_conv_across_channels_update_success: 'Successfully updated sync conversation across channels',
  sync_conv_across_channels_update_failed: 'Failed to update sync conversation across channels',
  confirmation_dialog_title: 'Settings override confirmation',
  confirmation_dialog:
    'Sharing a Web Messaging connection with a Mobile Messaging SDK connection will override the following Mobile Messaging settings to ensure conversation parity:',
  confirm_update: 'Would you like to confirm the save ?',
  stop_sharing_connection: 'STOP SHARING CONNECTION',
  go_back: 'Go Back',
  sdk_connection_selection: 'Please select one SDK connection',
  disabled_sdk_tooltip: "Editing the Mobile Messaging connection is disabled while it's being shared with {0}",
  connection_id_sdk: 'Connection Id :',
  account_name_sdk: 'Account Name :',
  sdk_push_notification: 'Push Notifications',
  session_control_disable_note: 'Chat session control is disabled while simultaneous conversations is enabled',
  context_config: 'Context data fields',
  avatar_config: 'Avatar Selections',
  private_config: 'Private data API JWT key',
  proactive_config: 'Proactive chat configurations',
  attachment_config: 'Customer upload attachments setting',
  virus_config: 'Virus scanning setting',
  text_config: 'State of text input area for quick reply type menu setting',
  session_config: 'Control chat session initialization (required for asynchronous messaging)',
};

const contextDataLabels = {
  display_name: 'Display Name',
  tag: 'Tag',
  tags: 'Tags',
  ip_address: 'IP address',
  location: 'Location',
  device: 'Browser/device',
  current_page: 'Current page',
  general_information: 'General information',
  context_data_captured_without_website_configuration_text:
    'Chat context data points which can be captured without website configuration',
  context_data_warning_text:
    'This functionality is not supported for Pega Customer Service versions prior to 8.6. Attempting to configure these settings on an unsupported version could result in unanticipated issues.',
  context_data_configuration_title_text_chat:
    'Configure chat context data which can be displayed to a CSR when they are chatting with a customer. General chat context data points will work without any website configuration, but custom tags will require implementation on your website.',
  context_data_configuration_title_text_mobile_sdk:
    'Configure SDK context data which can be displayed to a CSR when they are messaging with a customer. Context data can be displayed without any configuration required in SDK.',
  documentation_link_text: 'See documentation for more information',
  tags_description_text:
    'Define tags which can be added to your website to capture custom chat context data to be passed to any CSR interacting with a customer via web chat.',
  tags_description_text_sdk:
    'Define tags that can be added to your mobile app to capture custom chat context data to be passed to any CSR/BOT interacting with a customer via Mobile Messaging SDK.',
  no_spaces_special_chars: 'No spaces or special characters',
  copy_code_snippet: 'Copy code snippet',
  copy_code_snippet_for_tags: 'Copy code snippet for Tags',
  no_tags_configured: 'No Tags Configured',
  placeholder_for_customer_info: 'Placeholder for Customer Info',
  copy_tags_popup_snippet_title:
    'Copy the code below and paste it above the tag on each page you want information tracked',
  device_os: 'Device/OS',
  font_name: 'Font file name',
  byok_context_data_info: 'For BYOK connections context data fields like IP address, Location, XXX can not be enabled.',
};

const securityTabLabels = {
  domains: 'Domains',
  cookies: 'Cookies',
  allowed_domains: 'Allowed domains',
  allowed_cookies: 'Allowed cookies',
  domains_section_description: 'The listed domains are allowed to display the chat widget',
  cookies_section_description:
    'Cookie allow-list for passing information between your website and your Pega Customer Service implementation.',
  domain_validation_message:
    'Please enter valid domain with HTTPS. Paths, query strings and fragments will not be considered',
  jwt_secret_label: 'JWT Secret',
  jwt_secret_description: 'Use the JWT secret below to sign requests while exchanging private data',
  jwt_secret_description_sdk: 'Use the JWT secret below to sign requests while communication with API',
  jwt_secret_description_3rd_party:
    'Use the JWT secret to sign requests while communicating with the Digital Messaging Service',
  client_Webhook: 'Client Webhook',
  connection_id: 'Connection Id (JWT issuer)',
  digital_messaging_webhook: 'Digital Messaging Webhook',
  previous_interactions: 'Show previous interactions to authenticated customers',
  sdk_async_history: 'Conversation history',
  chat_session_control: 'Chat session control and asynchronous messaging/conversation history',
  chat_session_control_toggle: 'Control chat session initialization (required for asynchronous messaging)',
  chat_session_control_confirm: 'Confirm chat session initialization',
  chat_session_control_confirmation_agreement:
    'You need to implement the create session API in order to allow the customer to start a chat session',
  encryption_disabled_hover_text:
    'This connection has been disabled due to missing Client Public Key in your channel interface. Keys are required for enabling BYOK encryption.',
  e2ee_confirm_heading: 'Create your connection with standard or BYOK encryption?',
  standard_encryption: 'Standard encryption',
  byok_encryption: 'BYOK encryption',
  e2ee_description_1:
    'Bring your own key (BYOK) encryption encrypts conversations end to end using the keys which you have saved in Pega platform.',
  e2ee_description_2:
    'With platform version 8.8.0, BYOK encryption does not apply to attachments, transcript download, or conversation history.',
  e2ee_description_3:
    'You can still use these features, but they will be encrypted using standard encryption, not BYOK.',
  e2ee_description_4:
    'You will not be able to switch between standard and BYOK encryption for an existing Web Messaging or Mobile Messaging SDK connection. To make the change, you will have to delete the connection and create a new one.',
  e2ee_Dialog: 'End to End encrypted conversations are enabled on this connection.',
  e2ee_info_banner:
    'This connection is configured to use BYOK encryption, and all messages will be encrypted using the keys which you have provided. On your version of Pega Platform and Customer service, BYOK encryption does not cover transcripts or conversation history. These features will use standard encryption and can be toggled off.',
};

const installationLabels = {
  copy_snippet_description:
    'Copy the below content and paste it above the </body> tag on each page you want the chat widget to appear',
  api_id: 'Api id',
  api_url: 'Api url',
};

const proactiveMessagingLabels = {
  edit_proactive_messaging: 'Edit proactive message',
  select_channels_to_be_transferred_to: 'Select which channels a conversation can be transferred to',
  copy_below_snippet_for_proactive: 'Copy the code below and paste it above the tag on each page',
};

const chatAudioNotificationLabels = {
  sound: 'Sound',
  select_sound: 'Select sound',
  audio_notifications: 'Sound notifications',
  choose_when_to_play: 'Choose when to play',
  dont_play_sound: `Don't Play Sound Notifications`,
  play_on_every_message: 'Play On Every Message',
  play_when_not_visible: 'Play Only When Not Visible',
  audio_notifications_updated: 'Sound notifications updated',
  audio_notifications_update_failed: 'Failed to update sound notifications',
};

const mobileMessagingTabLabels = {
  'Mobile messaging': 'Mobile messaging',
};

const chatLanguagesTabLabels = {
  language: 'Language',
  supported_languages: 'Supported languages',
  language_settings_updated: 'Language settings updated',
  language_settings_update_failed: 'Failed to update language settings',
  default_language: 'Default language',
  system_field_localization: 'Web Messaging field localization',
  upload_custom_localization: 'Upload custom localization',
  custom_field_localization_template: 'Custom field localization template',
  customized_language_codes: 'Customized Language Codes',
  download: 'Download',
  choose_file: 'Choose File',
};

const chatHeadingLabels = {
  add_chat_heading: 'Add chat heading',
  add_chat_heading_for_another_language: 'Add chat heading for another language',
  widget_languages_note:
    'Configuring chat headings and pinned messages is available for all languages enabled in your Channel interface',
  add_special_notes: 'Add pinned message',
  add_special_note_for_another_language: 'Add pinned message for another language',
};

const proactiveChatLabels = {
  enabled: 'Enable',
  proactive_trigger: 'Proactive trigger',
  display_name: 'Display name',
  bot_command: 'Bot command',
  add_proactive_trigger_success: 'Proactive trigger added successfully',
  update_proactive_trigger_success: 'Proactive trigger updated successfully',
  delete_proactive_trigger_success: 'Proactive trigger deleted successfully',
  add_proactive_trigger_failure: 'Failed to add proactive trigger',
  update_proactive_trigger_failure: 'Failed to update proactive trigger',
  delete_proactive_trigger_failure: 'Failed to delete proactive trigger',
  copy_code_snippet_for_proactive_trigger: 'Copy code snippet for proactive trigger',
};

const pushNotificationsLabels = {
  webhook_url_title: 'Configure Webhook URL that can receive messages when the user is away from the app.',
  sdk_push_notification_note: 'SDK does not send push notifications directly to the device.',
  custom_headers: 'Custom headers',
  header_key: 'Header key',
  header_value: 'Header value',
  valid_key_error: 'Please enter valid key',
  key_empty_error: 'Key cannot be empty',
  value_empty_error: 'Value cannot be empty',
  no_headers_configured: 'No Headers Configured',
  header_desc:
    'Add any headers (custom or otherwise) that your server may require or expect when the webhook is called. For example, Authorization, x-custom-1 etc.',
};

const avatarLabels = {
  csrAvatar_update_success: 'Successfully updated CSR avatar type.',
  botAvatar_update_success: 'Successfully updated Bot avatar type.',
  userAvatar_update_success: 'Successfully updated User avatar type.',
  csrAvatar_update_failed: 'Failed to update CSR avatar type.',
  botAvatar_update_failed: 'Failed to update Bot avatar type.',
  userAvatar_update_failed: 'Failed to update User avatar type.',
  csrAvatar_label: 'CSR avatar type',
  botAvatar_label: 'Bot avatar type',
  userAvatar_label: 'Customer avatar type',
  csrAvatar: 'CSR',
  botAvatar: 'Bot',
  userAvatar: 'Customer',
  default_avatar: 'Default',
  custom_avatar: 'Custom',
  hidden_avatar: 'Hidden',
};

const colorPickerLabels = {
  message_font_color: 'Message font color',
  message_bg_color: 'Message background color',
  botAvatar_FontColor_update_success: 'Successfully updated Bot font color',
  botAvatar_BgColor_update_success: 'Successfully updated Bot background color',
  csrAvatar_FontColor_update_success: 'Successfully updated CSR font color',
  csrAvatar_BgColor_update_success: 'Successfully updated CSR background color',
  userAvatar_FontColor_update_success: 'Successfully updated User font color',
  userAvatar_BgColor_update_success: 'Successfully updated User background color',
  botAvatar_FontColor_update_failed: 'Failed to update Bot font color',
  botAvatar_BgColor_update_failed: 'Failed to update Bot background color',
  csrAvatar_FontColor_update_failed: 'Failed to update CSR font color',
  csrAvatar_BgColor_update_failed: 'Failed to update CSR background color',
  userAvatar_FontColor_update_failed: 'Failed to update User font color',
  userAvatar_BgColor_update_failed: 'Failed to update User background color',
  update_message_font_color_update_success: 'Successfully updated message and font color option',
  update_message_font_color_update_failed: 'Failed to update message and font color option',
};

const aiSimulatorLabels = {
  simulator_config: 'Simulator configuration for tasks',
  task: 'Task',
  queue_name: 'Queue Selection',
  pain_points: 'Pain Points',
  customer_config: 'Customer configuration - rapid CSR trainer',
  max_customers: 'Number of Customers',
  personality: 'Attitude / Personality',
  task_for_simulation:
    "Enter a description of the task you'd like the bot to complete during simulation e.g. 'Update the address on their account' or 'enroll in e-statements'",
  organization_name: 'Organization Name',
  escalation_command: 'Escalation Command',
  customer_details: 'Customer details',
  max_customer_tooltip:
    'The number of simulated interactions that are generated when a simulation is started. The maximum is capped by the number of personas configured in the Agent Trainer instance',
  escalation_command_tooltip:
    'The escalation command is the first message sent by the customer when a simulation is started. This value must match the create case command configured for the Chat with Agent case within your Digital Messaging channel in Pega',
  organization_name_tooltip:
    'Your organization name is used within the GenAI prompt to provide additional organization-specific context to the simulated customer, allowing them to fill in the context gaps for their assigned scenario',
  simulation_control_tooltip:
    "Use the Simulation Control toggle to begin or end customer simulation scenarios. Toggling to 'Start' will call the OpenAI API endpoint you've provided",
  simulation_scenario_tooltip:
    'The scenario or task that will be assigned to the simulated customer to complete during their interaction',
  queue_name_tooltip:
    'The Pega queue that the simulated customer will select for this scenario during their interaction',
  personality_tooltip:
    'The personality or temperament of the simulated customer that is assigned this scenario (e.g. Happy, frustrated, angry, confused)',
  pain_points_tooltip:
    'Additional modifiers or scenario-specific nuances used in the GenAI prompt for the simulated customer that is assigned this scenario (e.g. ‘doesn’t know their account number’,  ‘is bad at spelling’, ‘has already submitted duplicate claim online’)',
  resource_tooltip:
    'The Azure resource name. This can be found in your Azure GenAI endpoint URL \n https://{{resource}}.openai.azure.com/openai/deployments/{{deployment_id}}/chat/completions?api-version={{api-version}}',
  host_tooltip: 'The GenAI service that will be used',
  api_version_tooltip:
    'The Azure API version. This can be found in your Azure GenAI endpoint URL \n https://{{resource}}.openai.azure.com/openai/deployments/{{deployment_id}}/chat/completions?api-version={{api-version}}',
  client_id_tooltip: 'Your oAuth client ID',
  client_secret_tooltip: 'Your oAuth client secret',
  api_key_tooltip: 'Your oAuth api key',
  force_escalation: 'Force Escalation',
  force_escalation_tooltip:
    'When enabled, the simulated customer will immediately start the agent escalation using the Escalation command during their interaction',
  max_messages_tooltip: 'The maximum number of messages, a given customer is able to send during an interaction',
  get_models: 'Get models',
  get_models_error:
    'Error retreiving OpenAI models from Azure model list. Please ensure all of the resource fields have been input correctly.',
};

const aiSimulatorTabNames = {
  'Simulation configuration': 'Simulation configuration',
  'Connection and genAI': 'Connection and GenAI',
  'Live simulation': 'Live simulation',
  'Simulation history': 'Simulation history',
  Personas: 'Personas',
  'Agent feedback': 'Agent feedback',
};

const languageTabNames = {
  general_language_configurations: 'General language configurations',
  translate_to: 'Primary Business Language',
  order_of_consideration: 'Order of consideration for determining language',
  menu_selection: 'Menu selection',
  preferred_lang_context: 'Preferred language context data field',
  browser_lang: 'Browser language',
  primary_business_lang: 'Primary Business Language (Default Channel Language)',
  real_time_translations: 'Real-time translations',
  translation_service: 'Choose translation service',
  service_selection: 'Please select a service',
  primary_lang_csr: 'Primary language for CSRs',
  primary_lang_selection: 'Please select primary language',
  enabled_lang_selection: 'Please select enabled language to translate',
  google_service: 'Google Translate',
  api_key: 'API Key',
  translate_from: 'Customer languages enabled for translations',
  api_key_error: 'Please provide API key',
  save: 'Save',
  translation_success_primary_lang: 'Successfully updated primary business language',
  translation_success_from_lang: 'Successfully updated enabled language to translate',
  translation_service_update: 'Successfully updated real time translation service details',
  translation_success_primary_lang_update_failed: 'Failed to update primary business language',
  translation_success_from_lang_update_failed: 'Failed to update enabled language to translate',
  translation_service_update_update_failed: 'Failed to update real time translation service details',
  enable_language_translation: 'Enable real-time translations',
  translation_enabler_true: 'Successfully enabled language translation',
  translation_enabler_false: 'Successfully disabled language translation',
  translation_enabler_update_failed: 'Failed to update language translation',
  configure_language_and_localization: 'Configuring languages and localization for Web Messaging',
  real_time_translation_link_label: 'Real-time translation for web messaging',
  translate_to_tooltip:
    "The Digital Messaging service will translate incoming messages into the language selected here for the Customer Service Representative (CSR). The options in this dropdown menu correspond to the languages chosen within the Pega application's Channel Interface.",
  order_of_consideration_tooltip:
    "The Web Messaging widget identifies the customer's language based on the order of priority listed. If the widget is unable to ascertain the language using the top three options, it will default to the Primary Business Language as previously selected.",
  translate_from_tooltip:
    'The Digital Messaging service initially translates from the language specified here. The dropdown menu displays languages supported by the third-party translation service you have chosen.',
  translate_from_lang_error: 'Translate from cannot be empty',
  no_items: 'No items',
  byok_3rd_party_lang_info: 'For BYOK connections 3rd party translations could not be enabled.',
  system_field_localization_tooltip:
    'Web Messaging Field localizations refer to elements within the Web Messaging Widget that are adapted to supported languages based on the language identified in the widget session. This includes chat headers, dropdown menu text, and system messages.',
  custom_field_localization_temp_tooltip:
    'Custom field localizations uploaded in the following step will override the language settings of fields currently supported by the Pega Platform and also create language field settings for those not supported by Pega Platform. You will be responsible for managing any field IDs that have custom localizations linked to them. These custom localizations can be activated or deactivated from the Web Messaging Field localization menu by uploading new custom localizations, and also deleted directly from this menu using the x icon next to the language.',
  google_api_key_validation_update_failed: 'Failed to validate google api key',
  google_api_key_validation_success: 'Google Translate API key has been successfully authenticated.',
  invalid_google_api_key_warning:
    'Invalid Google Translate API Credentials. The provided API key or access token is not valid. If you do not have an account, you can sign up for Google Translate and obtain valid credentials to access the API. For more information',
  google_api_doc_link: 'Configuring Google Translate API key',
};

const chatPreview = {
  powered_by: 'Powered by',
  powered_by_pega: 'Powered by PEGA',
  bot_message: 'This is an example of bot agent message rendered in the widget preview',
  csr_message: 'This is an example of CSR message rendered in the widget preview',
  user_message: 'This is an example of customer message rendered in the widget preview',
  disabled_input_msg_menu: 'Please select a menu option',
  or: 'OR',
  enable_messaging: 'Click here to type another response',
  upload_attachment: 'Upload attachment',
  emoji_picker: 'Emoji picker',
  send_message: 'Send message',
  more_option: 'More options',
  minimize_chat: 'Minimize chat',
  open_chat: 'Open chat',
  type_message: 'Type a message',
  preview_note:
    'This is a statically rendered widget and is only meant to display the styling functionality based on your selected configuration options. The preview displays your styling selections with sample messages only. To test your messages, text box and menu dropdown please install the widget onto a website',
  contrast_warning: 'This token fails WCAG 2.1 AA accessibility contrast standards with the following pairs {0} & {1}',
};

const errorAlerts = {
  alerts_webhook: 'Alerts webhook',
  alert_desc: 'The webhooks below are triggered everytime an error occurs with this manager ID',
  webhook_url: 'Webhook URL',
  invalid_webhook: 'Given webhook url is invalid, please check again',
  maximum_limit_warning:
    'There is a maximum of 10 webhooks for each manager ID. To add a new webhook, please remove an existing one.',
  existing_error: 'The provided value is already present in the list',
  error_types: 'The payload below can be expected when an error event is triggered',
};

const stylingTabLabels = {
  widget_size_configuration: 'Widget size configurations',
  widget_size: 'Widget size',
  standard: 'Standard',
  large: 'Large',
  extra_large: 'Extra Large',
  configuration_definition_0: 'Select the desired widget size from the options below.',
  configuration_definition_1: 'Each size option includes specific height and width',
  configuration_definition_2: 'dimensions to fit different interface requirements:',
  configuration_definition_3: '  - 650px (height) x {0}px (width)',
  configuration_definition_4: '  - 943px (height) x {0}px (width)',
  configuration_definition_5: '  - 1822px (height) x {0}px (width)',
  widget_dimension_update_failed: 'Failed to update widget size configuration',
  widget_dimension_update_success: 'Successfully updated widget size configuration',
  allow_changing_widget_size: 'Allow customer to change widget size',
  allow_changing_widget_size_update_success: 'Successfully updated allow customer to change widget size',
  allow_changing_widget_size_update_failed: 'Failed to update allow customer to change widget size',
};

const agenticLoaderConfigLabels = {
  agentic_configurations: 'Agentic configurations - Dynamic response loader',
  enable_multi_phase_loader: 'Enable multi-phase loader',
  enable_multi_phase_loader_helper: 'Display different status messages as the agent processes the request',
  status_message: 'Status message',
  add_phrase: 'Add phrase',
  reset_to_default: 'Reset to default',
  remove_phase: 'Remove',
  drag_reorder: 'Drag to reorder',
  phase_label: 'Phase',
  phase_placeholder_prefix: 'e.g.',
  agentic_loader_status: 'Agent processing status',
  agentic_loader_update_success: 'Successfully updated agentic loader configuration',
  agentic_loader_update_failed: 'Failed to update agentic loader configuration',
  agentic_phase_thinking: 'Thinking',
  agentic_phase_analyzing: 'Analyzing data sources',
  agentic_phase_generating: 'Generating response',
  save_disabled_empty_fields: 'All phase status messages must be filled in before saving',
  save_disabled_no_changes: 'No changes to save',
  add_phrase_disabled_max_reached: 'Maximum number of phases reached',
  reset_disabled_already_default: 'Already using default values',
};

const chatTranslations = {
  ...chatAccountTabNames,
  ...chatBannerMessages,
  ...channelHopperLabels,
  ...chatFormErrorMessages,
  ...chatFormLabels,
  ...contextDataLabels,
  ...securityTabLabels,
  ...installationLabels,
  ...proactiveMessagingLabels,
  ...chatAudioNotificationLabels,
  ...chatLanguagesTabLabels,
  ...chatHeadingLabels,
  ...proactiveChatLabels,
  ...pushNotificationsLabels,
  ...avatarLabels,
  ...aiSimulatorLabels,
  ...aiSimulatorTabNames,
  ...languageTabNames,
  ...chatPreview,
  ...colorPickerLabels,
  ...errorAlerts,
  ...stylingTabLabels,
  ...mobileMessagingTabLabels,
  ...agenticLoaderConfigLabels,
};

export default chatTranslations;
